<template>
  <v-data-table
    :headers="serviceHeaders"
    :items="dataservice"
    :single-expand="singleExpand"
    :expanded.sync="expanded"
    :search="searchservice"
    item-key="id_service_activity"
    show-expand
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar
        flat
        class="mt-5"
      >
        <v-toolbar-title>Data Service  {{ activity.company_name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchservice"
          solo
          dense
          append-icon="mdi-magnify"
          :label="'Search Service '+activity.company_name"
          class="mr-3 white"
          outlined
          hide-details
        />
      </v-toolbar>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <v-row>
          <v-col>
            <v-simple-table>
              <tbody>
                <tr>
                  <td>Notes</td>
                  <td>{{ item.note }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </td>
    </template>
    <template #[`item.cost_for_child`]="{ item }">
      Rp. {{ Number(item.cost_for_child).toLocaleString() }}
    </template>
    <template #[`item.cost_for_adult`]="{ item }">
      Rp. {{ Number(item.cost_for_adult).toLocaleString() }}
    </template>
    <template #[`item.actions`]="{ item }">
      <v-btn
        small
        class="mr-2 text-capitalize primary"
        @click="UseService(item)"
      >
        Use Service
        <v-icon>{{ icons.mdiPlus }}</v-icon>
      </v-btn>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>
<script>
import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
} from '@mdi/js'
import axios from 'axios'

export default {
  props: ['activity'],
  data() {
    return {
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
      },
      modal1: false,
      modal2: false,
      dialog: false,
      dialog3: false,
      searchservice: '',
      expanded: [],
      editedIndex: -1,
      singleExpand: true,
      serviceHeaders: [
        { text: 'Detail Activity', value: 'detail_activity' },
        { text: 'Cost Child', value: 'cost_for_child' },
        { text: 'Cost Adult', value: 'cost_for_adult' },

        { text: 'Service Name', value: 'service_name' },

        {
          text: 'Actions', value: 'actions', sortable: false, width: 200,
        },
      ],
      record: {
        detail_activity: '',
        cost: '',
        note: '',
      },
      formservice: {
        service_name: '',
        id_activity: this.activity.id_activity,
        details: [],
      },
      dataservice: [],
    }
  },
  computed: {
  },
  watch: {
    activty(newVal, oldVal) {
      if (newVal.id_activity !== oldVal.id_activity) {
        this.initialize()
      }
    },
  },
  mounted() {
    this.initialize()
  },
  methods: {
    UseService(item) {
      this.$root.$emit('MakeItinerary', item, 'Activity')
    },
    DeleteService(index) {
      this.formservice.details.splice(this.formservice.details.indexOf(index), 1)
    },
    AddRecord() {
      this.formservice.details.push(this.record)
      this.record = {
        detail_activity: '',
        cost: '',
        note: '',
      }
    },
    CekDialog() {
      this.formservice = {
        service_name: '',
        id_activity: this.activity.id_activity,
        details: [],
      }
      this.dialog3 = false
    },
    editItem(item) {
      this.editedIndex = this.dataservice.indexOf(item)
      this.formservice.service_name = item.service_name
      this.formservice.id_activity = item.id_activity
      this.formservice.details = item.details
      this.dialog3 = true
    },
    initialize() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/getServiceActivity', { id_activity: this.activity.id_activity }).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.dataservice = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    deleteItem(item) {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/DeleteServiceActivity', item).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    Save() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/SaveServiceActivity', this.formservice).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
        this.dialog3 = false
        this.editedIndex = -1
        this.initialize()
        this.CekDialog()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
